module.exports = ".footer-align{\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n}\n.header-alignment{\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 1;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/submaster/submaster.component.css
// module id = ./src/app/components/submaster/submaster.component.css
// module chunks = main